import { useTranslation } from "react-i18next";
import {useState, useEffect, useContext} from "react";
import {useDispatch, useSelector} from "react-redux";
import DelimiterInput from "../DelimiterInput";
import {treeActions} from "../../../redux/slices/treeSlice";
import GroupByName from "../GroupByName";
import TPCheckbox from '../TPCheckbox';
import { Stack } from "@mui/material";
import { ParentScreenCtx } from "/src/pages/workbench_build/WorkbenchBuild";
import OverrideInboundDelimeter from "../OverrideInboundDelimeter";

export default function DelimitedMultipleSepForm() {
  const { t } = useTranslation();
  const parentScreen = useContext(ParentScreenCtx);
  const { rightTree } = useSelector(state => state.treeData[parentScreen]);
  const dispatch = useDispatch();
  const [recordDelimiter, setRecordDelimiter] = useState(false);
  const [fieldDelimiter, setFieldDelimiter] = useState(false);
  const [componentSeparator, setComponentSeparator] = useState(false);
  const [repetitionSeparator, setRepetitionSeparator] = useState(false);
  const [escapeCharacter, setEscapeCharactor] = useState(false);
  const [subcomponentSeparator, setSubcomponentSeparator] = useState(false);
  const [stripQuotes, setStripQuotes] = useState(false);
  const [trimData, setTrimData] = useState(false);
  const [decodeData, setDecodeData] = useState(false);
  const [unescapeData, setUnescapeData] = useState(false);

  useEffect(() => {
    const header = rightTree.tree.templateHeader;
    setRecordDelimiter(header?.LINEDELIMITER || '');
    setFieldDelimiter(header?.DELIMITER || '');
    setComponentSeparator(header?.GROUP_SEPARATOR || '');
    setRepetitionSeparator(header?.REPETITION_DELIMITER || '');
    setEscapeCharactor(header?.ESCAPE_CHARACTER || '');
    setSubcomponentSeparator(header?.SUBCOMPONENT_DELIMITER || '');
    setStripQuotes(
      header.UNCSV ?
        (typeof header.UNCSV === 'boolean' && header.UNCSV) || header.UNCSV === "TRUE" || false
        : false
    );
    setTrimData(
      header.TRIMDATA ?
        (typeof header.TRIMDATA === 'boolean' && header.TRIMDATA) || header.TRIMDATA === "TRUE" || false
        : false
    );
    setDecodeData(
      header.URLDECODE ?
        (typeof header.URLDECODE === 'boolean' && header.URLDECODE) || header.URLDECODE === "TRUE" || false
        : false
    );
    setUnescapeData(
      header.UNESCAPE_DATA ?
        (typeof header.UNESCAPE_DATA === 'boolean' && header.UNESCAPE_DATA) || header.UNESCAPE_DATA === "TRUE" || false
        : false
    );
  }, [rightTree.tree.templateHeader])

  const handleChange = (key, value) => {
    dispatch(treeActions.setRightTreeTemplateHeaders({ screen: parentScreen, key, value }));
  }

  return (
    <>
      <>
        <DelimiterInput
          default
          label={t('LBL_REC_DELIM_')}
          value={recordDelimiter}
          name={'LINEDELIMITER'}
        />
        <DelimiterInput
          default
          label={t('LBL_FLD_DELIM')}
          value={fieldDelimiter}
          name={'DELIMITER'}
        />
        <DelimiterInput
          default
          label={t('LBL_COMP_DELIM')}
          value={componentSeparator}
          name={'GROUP_SEPARATOR'}
        />
        <DelimiterInput
          default
          label={t('LBL_REPEAT_DELIM')}
          value={repetitionSeparator}
          name={'REPETITION_DELIMITER'}
        />
        <DelimiterInput
          default
          label={t('LBL_ESCAPE_DELIM')}
          value={escapeCharacter}
          name={'ESCAPE_CHARACTER'}
        />
        <DelimiterInput
          default
          label={t('LBL_SUB_COMP_DELIM')}
          value={subcomponentSeparator}
          name={'SUBCOMPONENT_DELIMITER'}
        />
      </>
      
      { parentScreen === 'inbound' && <>
        <div className="flex flex-wrap">
          <TPCheckbox 
            label={t('BTN_STRIP_QUOTES')}
            checked={stripQuotes}
            handleCheck={(checked) => {
              setStripQuotes(checked);
              handleChange('UNCSV', checked);
            }}
          />
          <TPCheckbox 
            label={t('BTN_TRIM_DATA')}
            checked={trimData}
            handleCheck={(checked) => {
              setTrimData(checked);
              handleChange('TRIMDATA', checked);
            }}
          />
          <TPCheckbox 
            label={t('BTN_URLDECODE_DATA')}
            checked={decodeData}
            handleCheck={(checked) => {
              setDecodeData(checked);
              handleChange('URLDECODE', checked);
            }}
          />
          <TPCheckbox 
            label={t('BTN_UNESCAPE_DATA')}
            checked={unescapeData}
            handleCheck={(checked) => {
              setUnescapeData(checked);
              handleChange('UNESCAPE_DATA', checked);
            }}
          />
        </div>
      <GroupByName />
      </>}
      {parentScreen === 'outbound' && <OverrideInboundDelimeter/>}

    </>
  )
}
